var React = require('react');

function ArrowRCerulean (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Arrow-side"},React.createElement("path",{"id":"Side","d":"M0.5 6.5L3 9L0.5 11.5","stroke":"#00B4DC","strokeWidth":"0.75"})));
}

ArrowRCerulean.defaultProps = {"width":"4","height":"20","viewBox":"0 0 4 20","fill":"none"};

module.exports = ArrowRCerulean;

ArrowRCerulean.default = ArrowRCerulean;
